import React from 'react';
import { mixed, object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Form, { Arquivo, Botao as BotaoForm, Campo } from 'Component/Form';
import Modal from 'Component/Modal';
import Modulo from 'Interface/Modulos';
import { useAdicionarMaterialMutation } from 'View/Service/Default/Materiais';

interface Props {
  exibir: boolean;
  unidadeDeAprendizagemId?: number;
  aoFechar: (estado: boolean) => void;
}

const regras = object({
  nome: string().nullable().required('Obrigatório'),
  url: mixed()
    .test('tamanho', 'O arquivo é muito grande', (valor) => {
      if (valor && valor.size) {
        return valor.size <= 2000000;
      }
      return true;
    })
    .test('tipo', 'Formato não suportado', (valor) => {
      if (valor && valor.type) {
        return [
          'application/pdf',
          'application/vnd.ms-powerpoint',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ].includes(valor.type);
      }
      return true;
    })
    .required('Obrigatório'),
});

const Adicionar = ({
  exibir,
  aoFechar,
  unidadeDeAprendizagemId,
}: Props): React.ReactElement => {
  const toast = useToast();
  const [adicionarMaterial] = useAdicionarMaterialMutation();

  const adicinar = async (dados: Modulo): Promise<void> => {
    try {
      await adicionarMaterial({
        ...dados,
        unidade_de_aprendizagem_id: unidadeDeAprendizagemId,
      }).unwrap();

      toast({ conteudo: 'Adicionado com sucesso!', tema: 'success' });

      aoFechar(false);
    } catch (erro) {
      toast({
        titulo: 'Erro ao adicionar',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <Modal exibir={exibir} aoFechar={aoFechar}>
      <Form onSubmit={adicinar} regras={regras}>
        <Arquivo name="url" />
        <Campo name="nome" rotulo="Nome do material" />
        <BotaoForm>Salvar</BotaoForm>
        <Botao ms onClick={() => aoFechar(false)} tema="light">
          Cancelar
        </Botao>
      </Form>
    </Modal>
  );
};

export default Adicionar;
